export default "__VITE_ASSET__CObRN43H__"